import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import { staffApi } from '../../lib/http';
import { PortalButton, PortalCard, PortalInput } from '../../components/portal/PortalElements';

export default function StaffProfile() {
  const [profile, setProfile] = useState(null);
  const [passwords, setPasswords] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });

  useEffect(() => {
    staffApi
      .get('/staff/profile')
      .then((response) => setProfile(response.data))
      .catch((error) => toast.error(error.message || 'Unable to load profile.'));
  }, []);

  async function updatePassword() {
    try {
      await staffApi.patch('/staff/profile/password', passwords);
      toast.success('Password changed successfully.');
      setPasswords({ currentPassword: '', newPassword: '', confirmPassword: '' });
    } catch (error) {
      toast.error(error.message || 'Unable to change password.');
    }
  }

  return (
    <div className="portal-grid portal-grid-main">
      <PortalCard>
        <div className="portal-section-head">
          <div>
            <p className="portal-kicker">Profile</p>
            <h2>Staff details</h2>
          </div>
        </div>
        <div className="portal-detail-grid">
          <div><strong>Name</strong><span>{profile?.name || '-'}</span></div>
          <div><strong>Username</strong><span>{profile?.username || '-'}</span></div>
          <div><strong>Mobile</strong><span>{profile?.mobile || '-'}</span></div>
          <div><strong>Email</strong><span>{profile?.email || '-'}</span></div>
          <div><strong>Designation</strong><span>{profile?.designation || '-'}</span></div>
          <div><strong>Role</strong><span>{profile?.role || '-'}</span></div>
        </div>
      </PortalCard>

      <PortalCard>
        <div className="portal-section-head">
          <div>
            <p className="portal-kicker">Security</p>
            <h2>Change password</h2>
          </div>
        </div>
        <div className="portal-stack">
          <PortalInput label="Current password" type="password" value={passwords.currentPassword} onChange={(event) => setPasswords((current) => ({ ...current, currentPassword: event.target.value }))} />
          <PortalInput label="New password" type="password" value={passwords.newPassword} onChange={(event) => setPasswords((current) => ({ ...current, newPassword: event.target.value }))} />
          <PortalInput label="Confirm password" type="password" value={passwords.confirmPassword} onChange={(event) => setPasswords((current) => ({ ...current, confirmPassword: event.target.value }))} />
          <PortalButton onClick={updatePassword}>Update password</PortalButton>
        </div>
      </PortalCard>
    </div>
  );
}
